export default __webpack_public_path__ + "static/media/34-lead.89f15a59.png";